<template>
  <v-container
    fluid
    class="py-0"
  >
    <top-bar
      header="Orders"
    />
    <v-row>
      <v-col
        cols="12"
        md="9"
        class="pt-0"
      >
        <v-tabs class="mb-6">
          <v-tab
            :to="{ name: 'Orders' }"
            exact
          >Open Orders</v-tab>
          <v-tab
            :to="{ name: 'PreviousOrders' }"
          >Previous Orders</v-tab>
          <!-- <v-tab
            :to="{ name: 'Returns' }"
          >Returns</v-tab> -->
        </v-tabs>
        <router-view />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <account-manager />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'OrdersOpen'
}
</script>
